import { useEffect, useRef } from "react";

import type { UnsplashTabContentProps } from "./UnsplashTabContent";
import { UnsplashTabContent } from "./UnsplashTabContent";

const DEFAULT_UNSPLASH_QUERY = "wallpapers";

export const UnsplashPanel = ({
  addUnsplash,
  searchUnsplash,
  unsplashResults,
}: UnsplashTabContentProps) => {
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;
    if (unsplashResults.length === 0) {
      searchUnsplash(DEFAULT_UNSPLASH_QUERY);
    }
  }, [searchUnsplash, unsplashResults.length]);

  return (
    <UnsplashTabContent
      unsplashResults={unsplashResults}
      searchUnsplash={searchUnsplash}
      addUnsplash={addUnsplash}
    />
  );
};
